import React, { Component } from "react"
import axios from "axios"
import Mixtapes from "../../shared/components/Mixtapes"
import MixtapeFilterSort from "./components/MixtapeFilterSort"
import MixtapeSearchBar from "./components/MixtapeSearchBar"
import MixtapeSelectedFiltersBar from "./components/MixtapeSelectedFiltersBar"
import NoResults from "./components/NoResults"
import PaginatedNavComponent from "../../shared/components/PaginatedNavComponent"

const RESULTS_PER_PAGE = 12

class MixtapesContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      allMixtapes: [],
      mixtapes: [],
      genreSelectOptions: [],
      selectedGenres: [],
      selectedSort: "default",
      selectedFilter: "",
      offset: 0,
      loading: true,
      noResults: false,
      limit: 0,
      searchTerm: "",
      filteredMixtapes: [],
    }

    this.updateMixtapes = this.updateMixtapes.bind(this)
    this.viewPage = this.viewPage.bind(this)
    this.showLoader = this.showLoader.bind(this)
  }

  componentDidMount() {
    
    this.fetchCurrentPageData()

    // Listen for back/forward navigation events
    window.addEventListener("popstate", this.fetchCurrentPageData.bind(this))
  }

  componentWillUnmount() {
    window.removeEventListener("popstate", this.fetchCurrentPageData.bind(this))
  }

  fetchCurrentPageData(){
    const urlParams = new URLSearchParams(window.location.search)
    const filterKeyword = urlParams.get("show")
    const page = parseInt(urlParams.get("page"), 10) || 1
    const offset = page * RESULTS_PER_PAGE - RESULTS_PER_PAGE

    if (filterKeyword) {
      this.showLoader()
      this.updateMixtapes({ name: "filter", value: filterKeyword, altered: true })
    } else {
      axios.get("/mixtapes/feed", { params: { offset } }).then((response) => {
        this.setState({
          ...this.state,
          offset: Math.max(offset, 0),
          loading: false,
          mixtapes: response.data.mixtapes,
          limit: response.data.total,
        })
      })
    }

    axios.get("/mixtapes/feed", { params: { fetchAll: true } }).then((response) => {
      this.setState({
        genreSelectOptions: this.getGenresOptions(response.data.mixtapes),
        allMixtapes: response.data.mixtapes,
      })
    })
  }

  getGenresOptions(mixtapes) {
    const raw = mixtapes.flatMap((m) => m.top_genres || m.genres || [])
    const uniq = Array.from(new Set(raw.filter(Boolean)))
    uniq.sort((a, b) => a.localeCompare(b))
    return [{ text: "All", value: "" }, ...uniq.map((g) => ({ text: g, value: g }))]
  }

  mixtapeGenres(m) {
    return (m.top_genres || m.genres || []).filter(Boolean)
  }

  matchesGenres(mixtape, selectedGenres) {
    if (!selectedGenres?.length) return true
    const gs = this.mixtapeGenres(mixtape)
    return selectedGenres.some((g) => gs.includes(g))
  }

  showLoader() {
    this.setState({ ...this.state, loading: true })
  }

  sortMixtapes(mixtapes, sort) {
    if (sort === "a-z") return mixtapes.sort((a, b) => a.name.localeCompare(b.name));
    if (sort === "z-a") return mixtapes.sort((a, b) => b.name.localeCompare(a.name));
    if (sort === "newest") return mixtapes.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    if (sort === "oldest") return mixtapes.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
    if (sort === "default") return mixtapes.sort((a, b) => (a.position || 0) - (b.position || 0));
    return mixtapes;
  }

  updateMixtapes(selected) {
    this.showLoader();

    const sel = selected && typeof selected === "object" ? selected : {};

    if (sel.name === "clear_all") {
      const offset = 0;
      const q = (this.state.searchTerm || "").trim().toLowerCase();

      if (q) {
        let filtered = this.state.allMixtapes
          .filter((m) => !m.secret)
          .map((m) => {
            const title = (m.name || "").toLowerCase();
            const desc  = (m.description || "").toLowerCase();
            const inTitle = title.includes(q);
            const inDesc  = desc.includes(q);
            if (!inTitle && !inDesc) return null;
            return { ...m, __relevance: inTitle ? 2 : 1 };
          })
          .filter(Boolean);

        filtered.sort((a, b) => b.__relevance - a.__relevance);
        filtered = this.sortMixtapes(filtered, "default");

        this.setState({
          selectedGenres: [],
          selectedSort: "default",
          selectedFilter: "",
          filteredMixtapes: filtered,
          noResults: filtered.length === 0,
          offset,
          loading: false,
          genreSelectOptions: this.buildDisabledOptions([]),
        });
      } else {
        this.setState({
          selectedGenres: [],
          selectedSort: "default",
          selectedFilter: "",
          filteredMixtapes: [],
          noResults: false,
          offset,
          loading: true,
          genreSelectOptions: this.buildDisabledOptions([]),
        });

        axios
          .get("/mixtapes/feed", {
            params: { genres: [], sort: "default", filter: "", offset },
          })
          .then((response) => {
            const { mixtapes } = response.data;
            this.setState({
              mixtapes,
              limit: response.data.total,
              loading: false,
            });
          });
      }
      return;
    }
    
    const urlParams = new URLSearchParams(window.location.search);
    const filterKeyword = urlParams.get("show");
    const page = parseInt(urlParams.get("page")) || 1;
    const offset = page * RESULTS_PER_PAGE - RESULTS_PER_PAGE;

    const genres = sel.options ? sel.options.map((o) => o.value) : sel.values ?? this.state.selectedGenres;
    const sort = sel.name === "sort" ? (sel.value || "default") : (this.state.selectedSort || "default");
    const filter = sel.name === "filter" ? sel.value : filterKeyword;

    if (this.state.searchTerm) {
      let filtered = this.sortMixtapes([...this.state.filteredMixtapes], sort);
      this.setState({
        selectedSort: sort,
        selectedGenres: genres,
        selectedFilter: filter,
        filteredMixtapes: filtered,
        offset,
        loading: false,
      });
      return;
    }

    if (genres && genres.length > 0) {
      let filtered = this.state.allMixtapes
        .filter((m) => !m.secret)
        .filter((m) => this.matchesGenres(m, genres));

      filtered = this.sortMixtapes(filtered, sort);

      this.setState({
        selectedSort: sort,
        selectedGenres: genres,
        selectedFilter: filter,
        filteredMixtapes: filtered,
        noResults: filtered.length === 0,
        offset: 0,
        loading: false,
        genreSelectOptions: this.buildDisabledOptions(genres),
      });
      return;
    }

    const params = { genres, sort, filter, offset };
    axios.get("/mixtapes/feed", { params }).then((response) => {
      const { mixtapes } = response.data;
      this.setState({
        loading: false,
        offset,
        selectedSort: sort,
        selectedGenres: genres,
        selectedFilter: filter,
        mixtapes,
        noResults: mixtapes.length === 0,
        limit: response.data.total,
        genreSelectOptions: this.buildDisabledOptions([]),
      });
    });
  }

  buildDisabledOptions(selectedGenresArr) {
    const selectedCount = selectedGenresArr.length
    return (this.state.genreSelectOptions || []).map((option) => {
      const keepEnabled =
        selectedCount < 3 || option.text === "All" || selectedGenresArr.includes(option.value)
      return keepEnabled ? { ...option, disabled: false } : { ...option, disabled: true }
    })
  }

  viewPage(page) {
    const offset = page * RESULTS_PER_PAGE - RESULTS_PER_PAGE

    if (this.state.searchTerm || this.state.selectedGenres.length > 0) {
      this.setState({ offset })
      return
    }

    const url = new URL(window.location.href)
    url.searchParams.set("page", page)
    window.history.pushState({}, "", url)

    const params = {
      offset,
      genres: this.state.selectedGenres,
      sort: this.state.selectedSort,
      filter: this.state.selectedFilter,
    }

    axios.get("/mixtapes/feed", { params }).then((response) => {
      const { mixtapes } = response.data
      this.setState({
        ...this.state,
        offset,
        loading: false,
        mixtapes,
        limit: response.data.total,
      })
    })
  }

  filterMixtapes(searchTerm) {
    const { allMixtapes, selectedSort } = this.state
    const lowerSearch = searchTerm.toLowerCase()

    if (searchTerm.trim() === "") {
      const urlParams = new URLSearchParams(window.location.search)
      const page = parseInt(urlParams.get("page")) || 1
      const offset = page * RESULTS_PER_PAGE - RESULTS_PER_PAGE

      this.setState({
        searchTerm: "",
        filteredMixtapes: [],
        noResults: false,
        offset,
      })
      return
    }

    let filtered = allMixtapes
      .filter((mixtape) => !mixtape.secret)
      .map((mixtape) => {
        const title = mixtape.name?.toLowerCase() || ""
        const description = mixtape.description?.toLowerCase() || ""
        const inTitle = title.includes(lowerSearch)
        const inDescription = description.includes(lowerSearch)
        if (!inTitle && !inDescription) return null
        return { ...mixtape, __relevance: inTitle ? 2 : 1 }
      })
      .filter(Boolean)

    filtered.sort((a, b) => b.__relevance - a.__relevance)
    filtered = this.sortMixtapes(filtered, selectedSort)

    this.setState({
      searchTerm,
      filteredMixtapes: filtered,
      noResults: filtered.length === 0,
      offset: 0,
    })
  }

  render() {
    const {
      mixtapes,
      loading,
      genreSelectOptions,
      selectedGenres,
      selectedSort,
      selectedFilter,
      noResults,
    } = this.state

    const usingLocalList = this.state.searchTerm || selectedGenres.length > 0
    const list = usingLocalList
      ? this.state.filteredMixtapes.slice(this.state.offset, this.state.offset + RESULTS_PER_PAGE)
      : mixtapes

    const totalCount = usingLocalList ? this.state.filteredMixtapes.length : this.state.limit

    return (
      <section id="mm-mixtapes">
        <article className="mixtapes">
          <div className="contain">
            <MixtapeSearchBar
              searchTerm={this.state.searchTerm}
              onSearchChange={(value) => this.filterMixtapes(value)}
            />

            <MixtapeFilterSort
              loading={loading}
              filterOptions={genreSelectOptions}
              selectedGenres={selectedGenres}
              selectedSort={selectedSort}
              selectedFilter={selectedFilter}
              updateMixtapes={this.updateMixtapes}
            />

            <MixtapeSelectedFiltersBar
              selectedGenres={selectedGenres}
              selectedSort={selectedSort}
              selectedFilter={selectedFilter}
              filterOptions={genreSelectOptions}
              onChange={this.updateMixtapes}
            />

            {list.length > 0 && (
              <div className="mixtapes-container">
                <Mixtapes mixtapes={list} />
              </div>
            )}
            {noResults && <NoResults />}
          </div>
        </article>

        {totalCount > RESULTS_PER_PAGE && (
          <PaginatedNavComponent
            key={`${this.state.searchTerm}-${selectedGenres.join(",")}-${this.state.offset / RESULTS_PER_PAGE + 1}`}
            count={totalCount}
            activePage={this.state.offset / RESULTS_PER_PAGE + 1}
            setActivePage={(page) => this.viewPage(page)}
            maxListOptions={7}
            resultsPerPage={RESULTS_PER_PAGE}
          />
        )}
      </section>
    )
  }
}

export default MixtapesContainer
